// extracted by mini-css-extract-plugin
export default {"cell-grid":"rvh9G"};